<div (click)="redirect()">
	<img [src]="item.icon">
	<div class="title">{{item.name}}</div>
	<div class="description">{{item.description}}</div>
</div>